import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
   resourcesSelector,
} from 'admin/state/modules/resources/selectors';
import { fetchResourcesOperation } from 'admin/state/modules/resources/operations';
import {
   isAllMediaFetchingSelector,
   isNewAllMediaFetchingSelector,
   isAllMediaEmptyByFilterSelector,
   isAllMediaFetchingByFilterSelector,
   isAllMediaEmptySelector,
   isInitedAllMediaSelector,
   allMediaFiltersSelector,
} from 'admin/state/modules/common/selectors';
import PageLoader from 'common/components/modules/page-loading';
import EmptyState from 'common/components/modules/empty-states';
import QueryParams from 'admin/utils/QueryParams.js'
import { allMediaSelector, screenWidthSelector, siteInfoSelector } from 'admin/state/modules/common/selectors';
import PullRefresh from 'admin/utils/PullRefresh.js';
import PullToRefresh from 'pulltorefreshjs';
import {
   checkAndUnlockDemoPublicSiteOperation,
   fetchAllMediaByFilterOperation,
   fetchAllMediaOperation,
   fetchNewAllMediaOperation,
   siteDetailsRefreshOperation,
} from 'admin/state/modules/common/operations';
import { isEmpty } from 'lodash'
import { changeInitedState } from 'admin/state/modules/photosets/actions';
import AllMedia from 'admin/views/all-media';
import { clearAllMediaState, updateMessageAction } from 'admin/state/modules/common/actions';


class AllMediaContainer extends Component {

   static propTypes = {
      data: PropTypes.object.isRequired,
      isFetching: PropTypes.bool.isRequired,
      fetchData: PropTypes.func.isRequired,
      fetchDataByFilter: PropTypes.func.isRequired,
      fetchNewData: PropTypes.func.isRequired,
      isNewFetching: PropTypes.bool,
      isEmpty: PropTypes.bool,
      isFetchingByFilter: PropTypes.bool,
      isEmptyByFilter: PropTypes.bool,
      resources: PropTypes.object,
      fetchResources: PropTypes.func,
      siteInfo: PropTypes.object,
      screenWidth: PropTypes.number,
      refreshSiteDetails: PropTypes.func,
      onSelectMedia: PropTypes.func,

      clearState: PropTypes.func,
      isInited: PropTypes.bool,

      selections: PropTypes.array,
      contentType: PropTypes.string,
      conversationId: PropTypes.number,
      onDeleteMessag: PropTypes.func,
      updateMessageAction: PropTypes.func,

      updateMessageUnlockDetails: PropTypes.func,
      hideScheduledContents: PropTypes.bool,
      hideUnpublishedContents: PropTypes.bool,
      checkAndUnlockDemoPublicSite: PropTypes.func,
      hiddenIds: PropTypes.string,
      filters: PropTypes.object,
   };

   static defaultProps = {
      hideScheduledContents: false,
      hideUnpublishedContents: false,
   }

   state = {
      photosetDataWithTips: null,
   }

   constructor(props) {
      super(props);
      this.state = {
         emptyFilters: true,
      };

      this.filter = {
         count: 20,
         page: 1,
      }
      this.keepInitedState = true

      this.filter = {
         ...this.filter,
         hideScheduledContents: !!this.props?.hideScheduledContents,
         hideUnpublishedContents: !!props?.hideUnpublishedContents,
         hiddenIds: props?.hiddenIds,
         ...props.filters,
      }
   }

   componentWillUnmount() {
      window.photosetScrollTop = window.pageYOffset
      const { clearState } = this.props;
      clearState({ allMediaFilters: this.filter, isInitedAllMedia: true  })

      let element = document.querySelector('#select-from-all_media')
      if(element) element.removeEventListener('scroll', this.handleScroll);

      PullRefresh.destroyAll();
   }

   componentDidMount() {
      const {
         fetchData,
         fetchResources,
         fetchDataByFilter,
         refreshSiteDetails,
         siteInfo: {
            site_status: siteStatus,
         },
         isInited,
         conversationId,
         filters,
         clearState,
      } = this.props;
      if(window.photosetScrollTop && isInited) {
         window.scroll({
            top: window.photosetScrollTop,
            left: 0,
         });
      }
      if('live' !== siteStatus) {
         refreshSiteDetails();
      }


      if(conversationId){
         this.filter = {
            ...this.filter,
            conversation: conversationId,
         }
      }
      let param = this.generateQuery()
      const params = QueryParams.getFilters();
      const emptyFilterParams = isEmpty(params)

      this.filter = {
         ...this.filter,
         ...filters,
      }

      const { count,
         //  status
      } = this.filter
      let otherKeys = Object.keys(this.filter).filter(it => !(['conversation', 'count', 'page', 'status', 'hideScheduledContents', 'hideUnpublishedContents', 'hiddenIds'].includes(it)))

      this.setState({
         emptyFilters: count === 20 && otherKeys.length === 0,
      })

      clearState({ allMediaFilters: this.filter  })

      fetchResources();
      if(!isInited) {
         fetchData(param, emptyFilterParams)
      }

      PullToRefresh.init({
         ...PullRefresh.init(),
         onRefresh: (done) => {
            this.filter = { ...this.filter, page: 1, count: 20 };
            param = this.generateQuery()
            if(param){
               fetchDataByFilter(param)
               done();
            } else {
               fetchData(param, emptyFilterParams)
               done();
            }
         },
      });

      let element = document.querySelector('#select-from-all_media')
      if(element) {
         element.scrollTo({ top: 0 })
         element.addEventListener('scroll', this.handleScroll);
      }
   }

   generateQuery = () => {
      const query = [];
      Object.keys(this.filter).forEach((key) => {
         if(key){
            if(this.filter[key]) {
               'conversation' !== key && key !== 'count' && key !== 'page' && key !== 'sortBy'  && key !== 'hideScheduledContents' && key !== 'hideUnpublishedContents' ?
                  key === 'hiddenIds' ?
                     query.push(`hiddenIds[]=${ this.filter[key] }`)
                     :
                     query.push(`query[]=${ key }=${ encodeURIComponent(this.filter[key]) }`) :
                  query.push(`${ key }=${ encodeURIComponent(this.filter[key]) }`);
            }
         }
      });
      return query;
   };

   handleScroll = (e) => {
      const { isFetching } = this.props
      const { isAdded } = this.state;

      if(isFetching) return

      const { scrollHeight, clientHeight, scrollTop } =  e.target
      let diff = (scrollHeight - scrollTop) - clientHeight

      if(diff < 100 && !isAdded) {
         this.nextPage()
      }
   }

   nextPage = async () => {
      const { fetchNewData, isNewFetching, data } = this.props;
      let query = [];
      let fetching = isNewFetching;
      let list = data;

      const { current_page: currentPage, last_page: pages } = list

      if(currentPage < pages && !fetching) {
         this.filter = { ...this.filter, page: currentPage + 1 };
         query = this.generateQuery();
         await fetchNewData(query);
      }
   }

   onFilterChange = (value, key) => {
      const { fetchDataByFilter } = this.props
      let data = value
      let emptyFilters = true

      if(!!Array.isArray(value)) {
         data = value.join(',')
      }

      this.filter = {
         ...this.filter,
         [key]: data,
         page: 1,
      }

      Object.keys(this.filter).forEach((key) => {
         if(!['conversation', 'count', 'hideScheduledContents', 'hideUnpublishedContents', 'page', 'hiddenIds'].includes(key)) {
            if(!!this.filter[key]) emptyFilters = false
         }
      })

      this.setState({ emptyFilters })
      let query = this.generateQuery()
      fetchDataByFilter(query)
   }

   onClearAllFilters = () => {
      const { conversationId, hideUnpublishedContents, hideScheduledContents, hiddenIds } = this.props
      this.filter = {
         count: 20,
         page: 1,
      }

      this.filter = {
         ...this.filter,
         hideScheduledContents,
         hideUnpublishedContents,
         hiddenIds,
      }
      if(conversationId){
         this.filter = {
            ...this.filter,
            conversation: conversationId,
         }
      }

      this.setState({
         emptyFilters: true,
      })
      let query = this.generateQuery()
      const { fetchDataByFilter } = this.props
      fetchDataByFilter(query)
   }

   generateUrlQuery = (filters, inited) => {
      if(filters && !isEmpty(filters)) {
         const urlParams = {};
         Object.keys(filters).forEach((key) => {
            if(key){
               if(key !== 'count' && key !== 'page') {
                  urlParams[key] = filters[key]
               }
               if(key === 'casts') {
                  urlParams.castmembers = filters[key]
                  delete urlParams.casts
               }
               if(!filters[key]) {
                  delete urlParams[key]
               }
            }
         });
         QueryParams.defineFilters(urlParams)
      }
      let params = QueryParams.getFilters()
      if(params.castmembers) {
         params.casts = params.castmembers
         delete params.castmembers
      }
      this.filter = { count: 20, page: 1, ...params };
      if(!inited){
         this.setState({
            emptyFilters: isEmpty(params),
         })
      }
   };

   handleCloseModalByUrl = () => {
      this.onTipModalClose()
   }

   cleanTipsState = () => {
      this.setState((...state) => {
         return {
            state,
            photosetDataWithTips: null,
         }
      })


   }

   render() {
      const {
         resources,
         screenWidth,
         onSelectMedia,
         siteInfo,
         selections,
         contentType,
         onDeleteMessag,
         updateMessageAction,
         updateMessageUnlockDetails,
         checkAndUnlockDemoPublicSite,
         data,
         isFetching,
         isNewFetching,
         isFetchingByFilter,
         isEmptyByFilter,
         isEmpty,
      } = this.props;
      const {
         emptyFilters,
      } = this.state;

      if(isFetching) {
         return (
            <div className='flex h-full w-full'>
               <PageLoader withLoader type='nonTab' customStyle='h-full w-full' />
            </div>
         )
      }

      return (
         <>
            {
               !!isEmpty ?
                  <div className='flex h-full items-center'>
                     <EmptyState
                        icon='media'
                        noContentText='You don’t have any media'
                        className='h-full'
                     />
                  </div>
                  :
                  <AllMedia
                     data={ data.data }
                     isEmpty={ isEmptyByFilter }
                     isFetchingByFilter={ isFetchingByFilter }
                     isNewFetching={ isNewFetching }
                     onFilterChange={ this.onFilterChange }
                     resources={ resources }
                     onClearAllFilters={ this.onClearAllFilters }
                     emptyFilters={ emptyFilters }
                     onSelectMedia={ onSelectMedia }
                     filters={ this.filter }
                     siteUrl={ siteInfo.site_url }
                     selections={ selections }
                     screenWidth={ screenWidth }
                     contentType={ contentType }
                     onDeleteMessag={ onDeleteMessag }
                     updateMessage={ updateMessageAction }
                     isDemoMode={ siteInfo?.site_status === 'demo_mode' }
                     updateMessageUnlockDetails={ updateMessageUnlockDetails }
                     checkAndUnlockDemoPublicSite={ checkAndUnlockDemoPublicSite }
                  />
            }
         </>
      )
   }
}

const mapStateToProps = state => ({
   data: allMediaSelector(state),
   isFetching: isAllMediaFetchingSelector(state),
   isNewFetching: isNewAllMediaFetchingSelector(state),
   isEmptyByFilter: isAllMediaEmptyByFilterSelector(state),
   isFetchingByFilter: isAllMediaFetchingByFilterSelector(state),
   isEmpty: isAllMediaEmptySelector(state),
   resources: resourcesSelector(state),
   screenWidth: screenWidthSelector(state),
   siteInfo: siteInfoSelector(state),
   isInited: isInitedAllMediaSelector(state),
   filters: allMediaFiltersSelector(state),
});

const mapDispatchToProps = dispatch => ({
   fetchData: (params = [], bool) =>  dispatch(fetchAllMediaOperation(params, bool)),
   fetchResources: () => dispatch(fetchResourcesOperation('all')),
   fetchDataByFilter: (params = []) =>
      dispatch(fetchAllMediaByFilterOperation(params)),
   fetchNewData: (params = []) => dispatch(fetchNewAllMediaOperation(params)),
   goTo: (location) => dispatch(push(location)),
   refreshSiteDetails: () => dispatch(siteDetailsRefreshOperation()),
   clearState: data => dispatch(clearAllMediaState(data)),
   changeInitedState: () => dispatch(changeInitedState()),
   updateMessageAction: data => dispatch(updateMessageAction(data)),
   checkAndUnlockDemoPublicSite: (callback) => dispatch(checkAndUnlockDemoPublicSiteOperation(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllMediaContainer);
